import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import {
  UserData,
  Response,
  QueryRequest,
  LocalStorageKeys,
  PreferenceRequest,
  PreferenceResponse,
  ContentType,
  UserPasswordRequest,
  PasswordResponse,
  UserSession,
  UserLanguageRequest,
  UserPinRequest,
  PinResponse,
} from '@models/index.model';
import { UtilsService } from '@services/index.service';

@Injectable()
export class UserService {
  private UrlAPI = environment.apiUrl;
  private UrlAuthAPI = environment.apiAuthUrl;

  constructor(private http: HttpClient, private _utils: UtilsService) {}

  // LocalStorage Methods.

  public getSessionDataFromLocalStorage(): UserSession {
    return (this._utils.getLocalStorage(LocalStorageKeys.SESSION_KEY) as UserSession);
  }

  public getUserDataFromLocalStorage(): UserData {
    return (this._utils.getLocalStorage(LocalStorageKeys.SESSION_KEY) as UserSession)?.userData;
  }

  public setUserDataToLocalStorage(userData: UserData) {
    let sessionData: UserSession = this._utils.getLocalStorage(LocalStorageKeys.SESSION_KEY);
    sessionData.userData.isSetPin = userData.isSetPin;
    this._utils.setLocalStorage(LocalStorageKeys.SESSION_KEY, sessionData);
  }

  public setUserDataLanguageToLocalStorage(lang: string) {
    let sessionData: UserSession = this._utils.getLocalStorage(LocalStorageKeys.SESSION_KEY) as UserSession;
    sessionData.userData.language = lang;
    this._utils.setLocalStorage(LocalStorageKeys.SESSION_KEY, sessionData);
  }

  // API METHODS.

  public getUserData(): Observable<Response<UserData>> {
    const query = this.UrlAPI + QueryRequest.user;
    return this.http.get<Response<UserData>>(query);
  }

  public changeUserData(userRequest: UserData): Observable<Response<UserData>> {
    const query = this.UrlAPI + QueryRequest.user;
    return this.http.put<Response<UserData>>(query, JSON.stringify(userRequest));
  }

  public changeUserLanguage(lang: UserLanguageRequest): Observable<Response<UserLanguageRequest>> {
    const query = this.UrlAPI + QueryRequest.userLanguage;
    return this.http.put<Response<UserLanguageRequest>>(query, lang);
  }

  public getUserPreference(preferenceRequest: PreferenceRequest): Observable<Response<PreferenceResponse>> {
    const query = this.UrlAPI + QueryRequest.userPreference;
    return this.http.post<Response<PreferenceResponse>>(query, JSON.stringify(preferenceRequest));
  }

  public setUserPreference(preferenceRequest: PreferenceRequest): Observable<Response<PreferenceResponse>> {
    const query = this.UrlAPI + QueryRequest.userPreference;
    return this.http.put<Response<PreferenceResponse>>(query, JSON.stringify(preferenceRequest));
  }

  public changeLoggedUserPassword(passwordRequest: UserPasswordRequest): Observable<Response<PasswordResponse>> {
    const query = this.UrlAuthAPI + QueryRequest.userPassword;
    return this.http.put<Response<PasswordResponse>>(query, this._utils.stringifyData(passwordRequest));
  }

  public changeUserPin(pinRequest: UserPinRequest): Observable<Response<PinResponse>> {
    const query = this.UrlAPI + QueryRequest.userPin;
    return this.http.put<Response<PinResponse>>(query, this._utils.stringifyData(pinRequest));
  }

  public getDocumentToSign(uri, documentId): Observable<any> {
    const query = uri;
    const httpHeaders = new HttpHeaders({'Content-Type' : ContentType.formDataType});
    const formdata: FormData = new FormData();
    formdata.append('documentId', documentId);

    return this.http.post(query, formdata, {
      observe: 'response',
      responseType: 'arraybuffer',
      headers: httpHeaders,
    });
  }
}
